export { default } from "./GuidedHighlightingStudentInfoPopup";
